import { AuthMethodMode } from './auth-method.i';
var AuthMethodBuilder = /** @class */ (function () {
    function AuthMethodBuilder() {
        this.authMethod = {
            mode: AuthMethodMode.DEFAULT,
            ssoConfig: {
                loginUrl: '',
                logoutUrl: ''
            }
        };
    }
    AuthMethodBuilder.prototype.withAuthMethodMode = function (mode) {
        this.authMethod.mode = mode;
        return this;
    };
    AuthMethodBuilder.prototype.withLoginUrl = function (url) {
        this.authMethod.ssoConfig.loginUrl = url;
        return this;
    };
    AuthMethodBuilder.prototype.withLogoutUrl = function (url) {
        this.authMethod.ssoConfig.logoutUrl = url;
        return this;
    };
    AuthMethodBuilder.prototype.build = function () {
        return this.authMethod;
    };
    return AuthMethodBuilder;
}());
export { AuthMethodBuilder };
//# sourceMappingURL=auth-method.builder.js.map